import { SelectionToolbarContent } from './SelectionToolbarContent'

import * as styles from './SelectionToolbar.module.css'

function SelectionToolbar(props) {
  const { contentClassName = styles.selectionToolbarModalContent } = props

  return (
    <div className={styles.SelectionToolbarModal}>
      <SelectionToolbarContent {...props} className={contentClassName} />
    </div>
  )
}

export default SelectionToolbar
